var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column gap-3"},[_c('vue-upload-images',{attrs:{"max":20,"id":("" + _vm.house_id)}}),_c('br'),_c('upload-floor-plan',{attrs:{"max":20,"id":("" + _vm.house_id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }